import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <span className="text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none">
        404
      </span>
      <h1 className="text-xl md:text-2xl font-bold text-foreground-950 mt-2">
        Página não encontrada
      </h1>
      <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
      <p className="mt-4 text-base text-foreground-500">
        Esta página não foi criada. Volte ao início ou nos conte o que você procura.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
      >
        Voltar ao Início
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-right-line text-sm"></i>
        </span>
      </Link>
    </div>
  );
}